import { useLocation } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import CookieDisclaimer from "./CookieDisclaimer";
import MobileCookieDisclaimer from "./MobileCookieDisclaimer";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import type { CookiePreferences } from "./CookieSettings";
import { PageTourManager } from "./PageTourManager";
import { BackgroundElements } from "./home/BackgroundElements";

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const isMobile = useIsMobile();
  const { hasConsent, giveConsent } = useCookieConsent();
  const location = useLocation();
  const isAuthRoute =
    location.pathname === "/auth" || location.pathname === "/reset-password";

  const handleAcceptCookies = (preferences: CookiePreferences) => {
    giveConsent(preferences);
  };

  const handleCloseCookies = () => {};

  if (isAuthRoute) {
    return (
      <div className="flex min-h-[100dvh] w-full overflow-x-hidden">
        <div className="flex-1 w-full relative z-0">{children}</div>
        {isMobile ? (
          <MobileCookieDisclaimer
            isVisible={hasConsent === false}
            onAccept={handleAcceptCookies}
            onClose={handleCloseCookies}
          />
        ) : (
          <CookieDisclaimer
            isVisible={hasConsent === false}
            onAccept={handleAcceptCookies}
            onClose={handleCloseCookies}
          />
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-[100dvh] w-full overflow-x-hidden">
      <BackgroundElements />
      <Navigation />
      <main className="flex-1 w-full relative z-0 pt-20 md:pt-[104px]">
        {children}
      </main>
      <Footer />
      <PageTourManager disabled={hasConsent === false} />
      {isMobile ? (
        <MobileCookieDisclaimer
          isVisible={hasConsent === false}
          onAccept={handleAcceptCookies}
          onClose={handleCloseCookies}
        />
      ) : (
        <CookieDisclaimer
          isVisible={hasConsent === false}
          onAccept={handleAcceptCookies}
          onClose={handleCloseCookies}
        />
      )}
    </div>
  );
};
